const camelCasetoNormalStrign = (str) => {
  const result = str.replace(/([A-Z])/g, ' $1').toLowerCase();
  const finalResult = result.charAt(1).toUpperCase() + result.slice(2);
  return finalResult;
};

export default camelCasetoNormalStrign;
